import { createStyles, CSSObject, MantineTheme, rem } from "@mantine/core";

export const useStyles = createStyles((theme: MantineTheme) => ({
  resultWrapper: {
    table: {
      border: "none",
      borderCollapse: "collapse",
      textAlign: "left",
      minWidth: rem(500),
      paddingBottom: rem(20),
      "th, td": {
        padding: "0.625rem",
      },
      th: {
        textOverflow: "initial",
        whiteSpace: "initial" as CSSObject["whiteSpace"],
        fontWeight: 600,
        lineHeight: 1.5,
        color: `${theme.colors.midnightBlue[0]}`,
        borderTop: "none",
        borderLeft: "none",
        borderRight: "none",
        borderBottom: "1px solid rgb(176, 182, 189)",
      },
      td: {
        lineHeight: 1.5,
        border: "none",
      },
    },
  },
}));
